import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './RequestSuccessful.style';

const ILLUSTRATION_URL =
  'https://res.cloudinary.com/zenbusiness/image/upload/v1/shared-assets/illustration/subscription-updated.svg';

export default function RequestSuccessful({ onClose }) {
  const { formatMessage } = useIntl();

  return (
    <>
      <DialogContent>
        <Styled.ContentStack alignItems="center">
          <Styled.IllustrationImage
            component="img"
            src={ILLUSTRATION_URL}
            alt={formatMessage({ id: 'dashboard.subscriptions.success.imageAlt' })}
          />
          <Styled.TitleText size="xl" weight="bold" align="center">
            <FormattedMessage id="dashboard.subscriptions.success.title" />
          </Styled.TitleText>
          <Text size="md" align="center" color="secondary">
            <FormattedMessage id="dashboard.subscriptions.success.body" />
          </Text>
        </Styled.ContentStack>
      </DialogContent>
      <Styled.ActionsContainer>
        <Button variant="contained" onClick={onClose} clickstreamProps={{ elementName: 'restart_success_close' }}>
          <FormattedMessage id="dashboard.subscriptions.success.ok" />
        </Button>
      </Styled.ActionsContainer>
    </>
  );
}

RequestSuccessful.propTypes = {
  onClose: PropTypes.func.isRequired,
};
